// extracted by mini-css-extract-plugin
export default {"btnDetail":"styles-scoped__btnDetail--FnzWy","actions":"styles-scoped__actions--y1ypd"};